import { DATA_LAYER_SCREEN_TYPES } from '../constants'
import { SmdlScreen } from '../types'
import cloneDeep from 'lodash/cloneDeep'

export const removeTrailingSlash = (path: string) => {
  if (path.endsWith('/')) {
    return path.substring(0, path.length - 1)
  }
  return path
}

export interface PathMapEntry {
  name?: string
  namePrefix?: string
  type: DATA_LAYER_SCREEN_TYPES
}

export const findPageAttrs = ({
  path,
  pathMap,
  regexPathMap,
}: {
  path: string
  pathMap: Record<string, PathMapEntry>
  regexPathMap: Record<string, PathMapEntry>
}): SmdlScreen | undefined => {
  const pathList = Object.keys(pathMap)
  const strictMatch = pathList.find((p) => p === path)
  if (strictMatch !== undefined) {
    return pathMap[strictMatch as keyof typeof pathMap]
  }

  const regexPathList = Object.keys(regexPathMap)
  const regexMatch = regexPathList.find((regexPath) => {
    const re = new RegExp(regexPath, 'i')
    return re.test(path)
  })
  if (regexMatch) {
    const regexPathObject = cloneDeep(
      regexPathMap[regexMatch as keyof typeof regexPathMap] as SmdlScreen
    )
    const { namePrefix } = regexPathObject
    if (namePrefix) {
      const regExpExecArray = new RegExp(regexMatch, 'i').exec(path)
      const match = regExpExecArray?.[1]
      regexPathObject.name = `${namePrefix}${match}`
      // Get rid of it otherwise this field will be sent to dmpg
      delete regexPathObject.namePrefix
    }
    return regexPathObject
  }
  return undefined
}
